import { useState } from 'react';
import { KeyboardArrowLeft } from '@mui/icons-material';
import { Box, Button, Stack, useTheme } from '@mui/material';
import { FieldValues, UseFormRegister } from 'react-hook-form';

import RowContainer from './components/RowContainer';
import RowContent from './components/RowContent';
import SectionTitle from './components/SectionTitle';

interface Props {
  studentGrade: number;
  studentGender: number;
  register: UseFormRegister<FieldValues>;
  isConfirmPassword: boolean;
  onConfirmPassword: () => void;
}

function Contents3(props: Props) {
  const { palette } = useTheme();

  const insulin = [
    [
      {
        label: '초속효성, 속효성 인슐린',
        link: 'https://www.youtube.com/watch?v=yKPIlHWunHo&list=PLVnfLGLhl7_B1aKIc4MD8hTom4wGw5UrL&index=17',
      },
      {
        label: '중간형, 지속형 인슐린',
        link: 'https://www.youtube.com/watch?v=rEAOLjqpTbY&list=PLVnfLGLhl7_B1aKIc4MD8hTom4wGw5UrL&index=18',
      },
      {
        label: '혼합형 인슐린',
        link: 'https://www.youtube.com/watch?v=OyBej3-PTZw&list=PLVnfLGLhl7_B1aKIc4MD8hTom4wGw5UrL&index=19',
      },
    ],
    [
      {
        label: '피하주사 투약 주의사항',
        link: 'https://www.youtube.com/watch?v=UiCfWC_xzHU&list=PLVnfLGLhl7_B1aKIc4MD8hTom4wGw5UrL&index=20',
      },
      {
        label: '인슐린 피하주사 실전',
        link: 'https://www.youtube.com/watch?v=jyg3_QGzG-o&list=PLVnfLGLhl7_B1aKIc4MD8hTom4wGw5UrL&index=21',
      },
      {
        label: '',
        link: '',
      },
    ],
  ];

  const IV = [
    [
      {
        label: 'IV(정맥주사)를 잘 하기 위한 기본',
        link: 'https://www.youtube.com/watch?v=eSug1rx2h5U&list=PLVnfLGLhl7_B1aKIc4MD8hTom4wGw5UrL&index=1',
      },
      {
        label: '토니켓(Tourniquet) 활용 방법',
        link: 'https://www.youtube.com/watch?v=S6do6gqoHMw&list=PLVnfLGLhl7_B1aKIc4MD8hTom4wGw5UrL&index=2',
      },
      {
        label: '용도에 맞는 needle 선택',
        link: 'https://www.youtube.com/watch?v=x_ZKHKPVVs4&list=PLVnfLGLhl7_B1aKIc4MD8hTom4wGw5UrL&index=3',
      },
    ],
    [
      {
        label: '수액 세트 활용, 수액 준비 과정과 주의 사항',
        link: 'https://www.youtube.com/watch?v=8gDT7GOeLEo&list=PLVnfLGLhl7_B1aKIc4MD8hTom4wGw5UrL&index=4',
      },
      {
        label: '실제 IV (정맥주사) 과정',
        link: 'https://www.youtube.com/watch?v=Jz1pDp9g9qQ&list=PLVnfLGLhl7_B1aKIc4MD8hTom4wGw5UrL&index=5',
      },
      {
        label: '',
        link: '',
      },
    ],
  ];

  const Antibiotic = [
    [
      {
        label: '페니실린계',
        link: 'https://www.youtube.com/watch?v=LfyJE1VGYsc&list=PLVnfLGLhl7_B1aKIc4MD8hTom4wGw5UrL&index=13',
      },
      {
        label: '세팔로스포린계',
        link: 'https://www.youtube.com/watch?v=cfMETiv0JQc&list=PLVnfLGLhl7_B1aKIc4MD8hTom4wGw5UrL&index=14',
      },
      {
        label: '카바페넴, 모노박탐, 옥사세펨, 퀴놀론',
        link: 'https://www.youtube.com/watch?v=FbKjxQ1XUHQ&list=PLVnfLGLhl7_B1aKIc4MD8hTom4wGw5UrL&index=15',
      },
    ],
    [
      {
        label: '반코마이신',
        link: 'https://www.youtube.com/watch?v=S3S_rXEfZEM&list=PLVnfLGLhl7_B1aKIc4MD8hTom4wGw5UrL&index=16',
      },
      {
        label: '',
        link: '',
      },
      {
        label: '',
        link: '',
      },
    ],
  ];

  return (
    <Box sx={{ margin: '40px' }}>
      <SectionTitle title="인슐린" />

      <RowContainer xs={12} marginBottom={'30px'}>
        <RowContent title="">
          {insulin.map(item => {
            return (
              <Stack spacing={3} sx={{ mt: 2 }} direction="row">
                <Button
                  onClick={() => window.open(item[0].link)}
                  disabled={item[0].label === '' ? true : false}
                  color="inherit"
                  size="large"
                  fullWidth
                  sx={{
                    fontSize: '14px',
                    whiteSpace: 'nowrap',
                    ':hover': {
                      backgroundColor: `${palette.primary.main}`,
                      color: 'white',
                      boxShadow: ' 2px 2px 2px 2px lightGray;',
                    },
                    boxShadow: ' 2px 2px 2px 2px lightGray;',
                  }}
                >
                  {item[0].label}
                </Button>
                <Button
                  onClick={() => window.open(item[1].link)}
                  disabled={item[1].label === '' ? true : false}
                  color="inherit"
                  size="large"
                  fullWidth
                  sx={{
                    fontSize: '14px',
                    whiteSpace: 'nowrap',
                    ':hover': {
                      backgroundColor: `${palette.primary.main}`,
                      color: 'white',
                      boxShadow: ' 2px 2px 2px 2px lightGray;',
                    },
                    boxShadow: ' 2px 2px 2px 2px lightGray;',
                  }}
                >
                  {item[1].label}
                </Button>
                <Button
                  onClick={() => window.open(item[2].link)}
                  disabled={item[2].label === '' ? true : false}
                  color="inherit"
                  size="large"
                  fullWidth
                  sx={{
                    fontSize: '14px',
                    whiteSpace: 'nowrap',
                    ':hover': {
                      backgroundColor: `${palette.primary.main}`,
                      color: 'white',
                      boxShadow: ' 2px 2px 2px 2px lightGray;',
                    },
                    boxShadow: ' 2px 2px 2px 2px lightGray;',
                  }}
                >
                  {item[2].label}
                </Button>
              </Stack>
            );
          })}
        </RowContent>
      </RowContainer>

      <SectionTitle title="정맥주사" />

      <RowContainer xs={12} marginBottom={'30px'}>
        <RowContent title="">
          {IV.map(item => {
            return (
              <Stack spacing={3} sx={{ mt: 2 }} direction="row">
                <Button
                  onClick={() => window.open(item[0].link)}
                  disabled={item[0].label === '' ? true : false}
                  color="inherit"
                  size="large"
                  fullWidth
                  sx={{
                    fontSize: '14px',
                    whiteSpace: 'nowrap',
                    ':hover': {
                      backgroundColor: `${palette.primary.main}`,
                      color: 'white',
                      boxShadow: ' 2px 2px 2px 2px lightGray;',
                    },
                    boxShadow: ' 2px 2px 2px 2px lightGray;',
                  }}
                >
                  {item[0].label}
                </Button>
                <Button
                  onClick={() => window.open(item[1].link)}
                  disabled={item[1].label === '' ? true : false}
                  color="inherit"
                  size="large"
                  fullWidth
                  sx={{
                    fontSize: '14px',
                    whiteSpace: 'nowrap',
                    ':hover': {
                      backgroundColor: `${palette.primary.main}`,
                      color: 'white',
                      boxShadow: ' 2px 2px 2px 2px lightGray;',
                    },
                    boxShadow: ' 2px 2px 2px 2px lightGray;',
                  }}
                >
                  {item[1].label}
                </Button>
                <Button
                  onClick={() => window.open(item[2].link)}
                  disabled={item[2].label === '' ? true : false}
                  color="inherit"
                  size="large"
                  fullWidth
                  sx={{
                    fontSize: '14px',
                    whiteSpace: 'nowrap',
                    ':hover': {
                      backgroundColor: `${palette.primary.main}`,
                      color: 'white',
                      boxShadow: ' 2px 2px 2px 2px lightGray;',
                    },
                    boxShadow: ' 2px 2px 2px 2px lightGray;',
                  }}
                >
                  {item[2].label}
                </Button>
              </Stack>
            );
          })}
        </RowContent>
      </RowContainer>

      <SectionTitle title="항생제" />

      <RowContainer xs={12}>
        <RowContent title="">
          {Antibiotic.map(item => {
            return (
              <Stack spacing={3} sx={{ mt: 2 }} direction="row">
                <Button
                  onClick={() => window.open(item[0].link)}
                  disabled={item[0].label === '' ? true : false}
                  color="inherit"
                  size="large"
                  fullWidth
                  sx={{
                    fontSize: '14px',
                    whiteSpace: 'nowrap',
                    ':hover': {
                      backgroundColor: `${palette.primary.main}`,
                      color: 'white',
                      boxShadow: ' 2px 2px 2px 2px lightGray;',
                    },
                    boxShadow: ' 2px 2px 2px 2px lightGray;',
                  }}
                >
                  {item[0].label}
                </Button>
                <Button
                  onClick={() => window.open(item[1].link)}
                  disabled={item[1].label === '' ? true : false}
                  color="inherit"
                  size="large"
                  fullWidth
                  sx={{
                    fontSize: '14px',
                    whiteSpace: 'nowrap',
                    ':hover': {
                      backgroundColor: `${palette.primary.main}`,
                      color: 'white',
                      boxShadow: ' 2px 2px 2px 2px lightGray;',
                    },
                    boxShadow: ' 2px 2px 2px 2px lightGray;',
                  }}
                >
                  {item[1].label}
                </Button>
                <Button
                  onClick={() => window.open(item[2].link)}
                  disabled={item[2].label === '' ? true : false}
                  color="inherit"
                  size="large"
                  fullWidth
                  sx={{
                    fontSize: '14px',
                    whiteSpace: 'nowrap',
                    ':hover': {
                      backgroundColor: `${palette.primary.main}`,
                      color: 'white',
                      boxShadow: ' 2px 2px 2px 2px lightGray;',
                    },
                    boxShadow: ' 2px 2px 2px 2px lightGray;',
                  }}
                >
                  {item[2].label}
                </Button>
              </Stack>
            );
          })}
        </RowContent>
      </RowContainer>
    </Box>
  );
}

export default Contents3;
